export default __webpack_public_path__ + "static/Pinata_SteveSimkins-f45b91d3382f70338dbcce33cd84f97d.jpg";